<template>
  <popup buttonStyle="info"
  heading="Permit"
  size="medium"
  :showText="showText"
  buttonText="New Permit"
  buttonIcon="fa fa-paperclip"
  :disableButton="!isManager('admin|finance|management|property') || readOnly"
  @save="onSaveDialog"
  @close="onCloseDialog">

  <permit-details ref="adp" :row-data="rowData" :siteId="rowData.id"
  :editMode="true" :adding="true" :hide-panel="true"
  :table-ref="tableRef" />
</popup>

</template>


<script>
import PermitDetails from '@/components/sites/permits/PermitDetails'

export default {
  components: {
    PermitDetails
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'permittable'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    onSaveDialog () {
      this.$refs.adp.onSave()
    },

    onCloseDialog () {
      this.$refs.adp.onClose()
    }
  },

  data () {
    return {
      form: this.getTableStruct('permits')
    }
  }
}
</script>
